var map = {
	"./ar-ar.png": 803,
	"./chi-chi.png": 804,
	"./de-de.png": 805,
	"./en-us.png": 806,
	"./es-es.png": 807,
	"./fr-fr.png": 808,
	"./hi-hi.png": 809,
	"./it-it.png": 810,
	"./ja-ja.png": 811,
	"./ko-ko.png": 812,
	"./pl-pl.png": 813,
	"./ru-ru.png": 814,
	"./tur-tur.png": 815,
	"./ua-ua.png": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;